import setup from './moduleSetup';

export default {
    name: 'warehouses',
    before: [],
    after: [],
    setup,
};
